import { Localized } from "@fluent/react";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import { ListItem, ListItemText } from "@mui/material";

type AppConnectedUIProps
    = { type: 'not_connected' }
    | { type: 'connected' | 'maybe_connected', relativeTime: string };

export default function AppConnectedUI(props: AppConnectedUIProps) {
    switch (props.type) {
        case 'connected':
            return <ListItem>
                <PhoneIphoneIcon color="primary" />
                <Localized id="alarm-group-list-app-connected"
                    vars={{ relativeTime: props.relativeTime }}>
                    <ListItemText />
                </Localized>
            </ListItem>;
        case 'maybe_connected':
            return <ListItem>
                <PhoneIphoneIcon color="warning" />
                <Localized id="alarm-group-list-app-connected"
                    vars={{ relativeTime: props.relativeTime }}>
                    <ListItemText />
                </Localized>
            </ListItem>;
        case 'not_connected':
            return <ListItem>
                <PhoneIphoneIcon color="error" />
                <Localized id="alarm-group-list-app-unconnected">
                    <ListItemText />
                </Localized>
            </ListItem>;
    }
}
